import React from "react";
import OrderSummary from "../../views/pos/orderSummary";
import ShopCardDetails from "../../views/shops/shopDetailsCard.jsx";
import DiscountList from "../../views/assetsManagement/ManageAssets.jsx";
import AssetsPage from "../../views/assetsManagement/ManageAssets.jsx";

import Rawmaterial from "../../views/RawMaterial/Rawmaterial.jsx";
import RawMaterialSupply from "../../views/RawMaterial/RawMaterialSupplies.jsx";
import BcShopList from "../../views/BcSetups/bcShoplist.jsx";


const InformationalDashboard = React.lazy(() => import("../../views/dashboard/InformationalDashboard"));
const ProductList = React.lazy(() => import("../../views/products/ProductCon"));

const AllProductList = React.lazy(() => import("../../views/products/AllBusinessProduct"));
const AllProductGrid = React.lazy(() => import("../../views/products/productgrid"));
const ProductDetails = React.lazy(() => import("../../views/products/ProductDetailCard.jsx"));
const Category = React.lazy(() => import("../../views/products/ProductsCategories.jsx"));
const Unit = React.lazy(() => import("../../views/products/UnitCon"));
const PromoProduct = React.lazy(() => import("../../views/products/ProductPromotion.jsx"));
const Uploads = React.lazy(() => import("../../views/products/UploadCon"));
const ProductTransferCon = React.lazy(() => import("../../views/products/ProductTransferCon"));
const AdjustmentCon = React.lazy(() => import("../../views/products/AdjustmentCon"));


//CUSTOMER
const CustomerCon = React.lazy(() => import("../../views/customer/CustomerCon"));
const customerDetails = React.lazy(() => import("../../views/customer/CustomerDeatils"));
const GroupList = React.lazy(() => import("../../views/customer/GroupCon"));
const Import = React.lazy(() => import("../../views/customer/Import"));
const AddCustomer = React.lazy(() => import("../../views/customer/addCustomer"));



//SUPPLIER
const AddSuppliers = React.lazy(() => import("../../views/customer/addSuppliers.jsx"));
const SupplierList = React.lazy(() => import("../../views/customer/supplierList.jsx"));
const supplierDetails = React.lazy(() => import("../../views/customer/supplierDetails.jsx"));


const SaleCon = React.lazy(() => import("../../views/sell/SaleCon"));
const DraftCon = React.lazy(() => import("../../views/sell/DraftCon"));
const ReturnsCon = React.lazy(() => import("../../views/sell/ReturnsCon"));
const SuspenseCon = React.lazy(() => import("../../views/sell/SuspenseCon"));


//SHOPS
const ShopList = React.lazy(() => import("../../views/shops/ShopList"));
const AddShops = React.lazy(()=> import("../../views/shops/AddShops"));
const ShopListbyId = React.lazy(()=> import("../../views/shops/shopListById"));
const Shopproducts = React.lazy(()=> import("../../views/shops/assinedProductsbyShops"));
const ShopCardDetail = React.lazy(()=> import("../../views/shops/shopDetailsCard.jsx"));
const AddShopDisplays = React.lazy(()=> import("../../views/shops/AddShopDisplays.jsx"));
const ShopProductDetails = React.lazy(()=> import("../../views/shops/shopProductDetails.jsx"));
const ShopPerPOS = React.lazy(()=> import("../../views/shops/shopPerPOS.jsx"));
const ShopOrderSummary = React.lazy(()=> import("../../views/shops/shopOrderSummary.jsx"));
const ShopTill = React.lazy(()=> import("../../views/shops/till.jsx"));
const AddShopTill = React.lazy(()=> import("../../views/shops/addtill.jsx"));
const TillcashmovementShop = React.lazy(()=> import("../../views/shops/tillcashmovent.jsx"));
const TillAssignShop = React.lazy(()=> import("../../views/shops/tillassignshop.jsx"));
const ShopSalesTransactions = React.lazy(()=> import("../../views/shops/shopSalesTransaction.jsx"));
const ShopReportTransactions = React.lazy(()=> import("../../views/shops/shopReportnAnalytics.jsx"));
const ShopDisplayInvemtories = React.lazy(()=> import("../../views/shops/ShopDisplayInventoriesList.jsx"));
const ShopDisplayLocations = React.lazy(()=> import("../../views/shops/shopDisplayLocations.jsx"));
const ShopDisplayProducts = React.lazy(()=> import("../../views/shops/shopDisplayProducts.jsx"));
const ShopTax = React.lazy(()=> import("../../views/shops/shoptaxes.jsx"));







//BUSINESS
const AddBusiness = React.lazy(()=> import("../../views/business/AddBusiness"));
const BusinessList = React.lazy(()=> import("../../views/business/BusinessList"));

//STAFF
const UserList = React.lazy(()=> import("../../views/business/BusinessList"));
const AddUsers = React.lazy(()=> import("../../views/settings/AddUsers"));
const userProfile = React.lazy(()=> import("../../views/shops/staffProfile"));
const adminProfile = React.lazy(()=> import("../../views/settings/profile"));
const employeesProfile = React.lazy(()=> import("../../views/settings/employeeProfile.jsx"));
const ResetPassword = React.lazy(()=> import("../../views/settings/ResetPassword"));


const PosLayout = React.lazy(()=> import("../../views/pos/poslayout"));
const OrderSummarys = React.lazy(()=> import("../../views/pos/orderSummary"));
const dailytransactions = React.lazy(()=> import("../../views/pos/dailyTransactions.jsx"));


//PRODUCT
const AddProduct = React.lazy(()=> import("../../views/products/ProductForm"));
const ProductCategoryList = React.lazy(()=> import("../../views/products/ProductCategoryList.jsx"));
const ProductTaxes = React.lazy(()=> import("../../views/products/ProductTaxes.jsx"));
const ProductDiscount = React.lazy(()=> import("../../views/products/ProductdDiscounts.jsx"));
const barCode = React.lazy(()=> import("../../views/settings/GenerateBarCode.jsx"));

//STAFF
const StaffListbyId = React.lazy(()=> import("../../views/staffs/staffListbyId"));
const StaffCard = React.lazy(()=> import("../../views/staffs/staffProfile.jsx"));




//WAREHOUSE
const AddWarehouse = React.lazy(()=> import("../../views/wareHouse/addWareHouse.jsx"));
const WarehouseList = React.lazy(()=> import("../../views/wareHouse/wareHouseList.jsx"));
const WarehouseProfile = React.lazy(()=> import("../../views/wareHouse/warehouseDetails.jsx"));
const AddWarehouseSegment = React.lazy(()=> import("../../views/wareHouse/addwarehousesagement.jsx"));
const AddWarehouseSupplies = React.lazy(()=> import("../../views/wareHouse/warehouseSupplies.jsx"));
const WarehouseInventoriesList = React.lazy(()=> import("../../views/wareHouse/warehouseInventories.jsx"));


//Promtoion
const AddPromotion = React.lazy(()=> import("../../views/promotions/addpromotions.jsx"));
const PromotionList = React.lazy(()=> import("../../views/promotions/promotionsList.jsx"));
const AddDiscount = React.lazy(()=> import("../../views/promotions/Adddiscount.jsx"));



//Till
const AddTill = React.lazy(()=> import("../../views/till/addTill.jsx"));
const ViewTill = React.lazy(()=> import("../../views/till/viewTills.jsx"));
const TillDetails = React.lazy(()=> import("../../views/till/tiillDetails.jsx"));
const TillAssign = React.lazy(()=> import("../../views/till/tillassignement.jsx"));
const Tillcashmovement = React.lazy(()=> import("../../views/till/addTillcashmovement.jsx"));
const Tax = React.lazy(()=> import("../../views/Tax/GetTax.jsx"))


const ForgotPassword = React.lazy(()=> import("../../views/settings/ForgotPassword.jsx"));
const ResetPassword2 = React.lazy(()=> import("../../views/auth/ResetPassword2.jsx"));





//POS FILE ONLY

// const PosPage = React.lazy(()=> import("../../views/POS FILE/posPage.jsx"));


const routes = [
    { path: "/dashboard/informational", component: InformationalDashboard },
    { path: "/product/product_list", component: ProductList },


    { path: "/product/allproduct_list", component: AllProductList },
    { path: "/product/allproduct_grid", component: AllProductGrid},
    { path: "/product/product_add", component: AddProduct },
    { path: "/product/details", component: ProductDetails },
    { path: "/product/productCategories", component: Category },
    { path: "/product/productCategoriesList", component: ProductCategoryList },
    { path: "/product/taxes", component: ProductTaxes },
    { path: "/product/discount", component: ProductDiscount },
    { path: "/product/uploads", component: Uploads },
    { path: "/product/stock_adjustment", component: AdjustmentCon },
    

    { path: "/customer/customer_list", component: CustomerCon },
    { path: "/customer/customerDetails", component: customerDetails },
    { path: "/customer/group_list", component: GroupList },
    { path: "/customer/add_customer", component: AddCustomer },
    { path: "/suppliers/addsupplier", component: AddSuppliers },
    { path: "/suppliers/supplierList", component: SupplierList },
    { path: "/suppliers/supplierDetail", component: supplierDetails },


    { path: "/sell/sale_list", component: SaleCon },
    { path: "/sell/draft", component: DraftCon },
    { path: "/sell/returns", component: ReturnsCon },
    { path: "/sell/suspense", component: SuspenseCon },


    {path: "/shops/shopList", component: ShopList},
    {path: "/shops/addShops", component: AddShops},
    {path: "/shops/shopListbyId", component: ShopListbyId},
    {path: "/shops/shopDetails", component: ShopCardDetail},
    {path: "/shops/addShopDisplays", component: AddShopDisplays},
    {path: "/shopproduct/details", component: ShopProductDetails},
    {path: "/shop/shopperpos", component: ShopPerPOS},
    {path: "/shop/shopOrderSummary", component: ShopOrderSummary},
    {path: "/shop/till", component: ShopTill},
    {path: "/shop/addtillshop", component: AddShopTill},
    {path: "/shop/tillcashmovement", component: TillcashmovementShop},
    {path: "/shop/assigntill"  , component: TillAssignShop},
    {path: "/shop/salesTransactions"  , component: ShopSalesTransactions},
    {path: "/shop/ReportTransactions"  , component: ShopReportTransactions},
    {path: "/shop/ShopDisplayInventories"  , component: ShopDisplayInvemtories},
    {path: "/shop/ShopDisplayLocations"  , component: ShopDisplayLocations},
    {path: "/shop-display-product"  , component: ShopDisplayProducts},
    {path: "/shopTax"  , component: ShopTax},
    



    {path: "/staffs/staffListbyId", component: StaffListbyId},
    {path: "/staff/staffCard", component: StaffCard},
    {path: "/business/addBusniess", component: AddBusiness},
    {path: "/business/busniessList", component: BusinessList},


    {path: "/wareHouse/addWareHouse" , component: AddWarehouse},
    {path: "/wareHouse/WareHouseList", component: WarehouseList},
    {path: "/wareHouse/profile", component: WarehouseProfile},
    {path: "/wareHouse/segment", component: AddWarehouseSegment},
    {path: "/wareHouse/supplies", component: AddWarehouseSupplies},
    {path: "/wareHouse/inventories", component: WarehouseInventoriesList},


    {path: "/settings/addUsers", component: AddUsers},
    {path: "/settings/resetPassword", component: ResetPassword},
    {path: "/shops/product", component: Shopproducts},
    {path:  "/user/profile" , component: userProfile},
    {path:  "/admin/profile" , component: adminProfile},
    {path:  "/employees/profile" , component: employeesProfile},

    {path:  "/business/barcode" , component: barCode},


    {path:  "/pos/layout" , component: PosLayout},
    {path:  "/order-summary" , component: OrderSummarys},
    {path:  "/pos/dailytransactions" , component: dailytransactions},


    {path: "/promotions/addpromotion" , component: AddPromotion},
    {path: "/promotions/promotion"  , component: PromotionList},
    {path: "/purchase/addDiscount"  , component: AddDiscount},
    


    {path: "/toss/forgotpassword"  , component: ForgotPassword},

    {path: "/toss/reset/forgotpassword"  , component: ResetPassword2},



    {path: "/till/addTill"  , component: AddTill},
    {path: "/till/viewTill"  , component: ViewTill},
    {path: "/till/tillDetails"  , component: TillDetails},
    {path: "/till/assigntill"  , component: TillAssign},
    {path: "/till/tillcashmovement"  , component: Tillcashmovement},
    




    {path: "/assets/assetsmanagement"  , component: AssetsPage},
    {path: "/rawmaterial/supplies"  , component: RawMaterialSupply},
    {path: "/rawmaterial/management"  , component: Rawmaterial},

    //BC FILES
    {path: "/bc-shop/bcshoplist"  , component: BcShopList},
     {path: "/bc-data/management"  , component: BcShopList},
    

    

//POS FILE ONLY
    // {path: "/posfile/pospage"  , component: PosPage},
    // {path: "/posfile/posSidebar"  , component: PosSideBar},
    // {path: "/posfile/pospage"  , component: PosPage},
    

    {path: "/manage/tax"  , component: Tax},

];

export default routes;
